<template>
  <f7-page class="page-home">
    <f7-navbar color="black">
      <f7-nav-left v-if="balanceLoad">
        <!-- <app-header
          :user-avatar="user.avatar"
          :user-name="user.name"
          :user-last-name="user.lastName"
          :worked-minutes="user.workedMins"
          :user-balance="user.balance"
        ></app-header> -->
        <f7-button
          class="button-with-badge gradient"
          round
          large
          fill
          @click="$store.dispatch('user/createWithdraw')"
        >
          Payout request
          <f7-badge
            v-if="user.canOut"
            f7-icon="info_round_fill"
            class="margin-left-half"
            color="red"
          >
            !
          </f7-badge>
        </f7-button>

        <f7-button class="button-with-badge gradient" round large fill href="/calendar">
          Calendar
          <f7-badge
            v-if="!user.calendar"
            f7-icon="info_round_fill"
            class="margin-left-half"
            color="red"
          >
            !
          </f7-badge>
        </f7-button>
        <f7-button class="button-with-badge gradient" round large fill href="/booking">
          Booking
          <f7-badge class="margin-left-half" :color="bookingCount ? 'red' : 'gray'">
            {{ bookingCount }}
          </f7-badge>
        </f7-button>
        <f7-button class="button-with-badge gradient" round large fill href="/proofread">
          Texts Tasks
          <f7-badge class="margin-left-half" :color="proofreadCount ? 'red' : 'gray'">
            {{ proofreadCount }}
          </f7-badge>
        </f7-button>
        <f7-button v-if="user.curator" class="gradient" round large fill href="/admin">
          Admin
        </f7-button>
      </f7-nav-left>

      <f7-nav-right>
        <UserTime class="margin-right"></UserTime>

        <f7-link href="/settings">
          <f7-icon f7="settings" size="22" color="pink"></f7-icon>
          <span class="collapse-1440">
            Settings
          </span>
        </f7-link>

        <f7-link :href="appConfig.help_link" target="_blank" external>
          <f7-icon f7="help_round" size="20" color="pink"></f7-icon>
          <span class="collapse-1440">
            Help
          </span>
        </f7-link>

        <f7-link class="logout-link" @click="logOut">
          <f7-icon f7="exit" size="22"></f7-icon>
          <span class="collapse-1440">
            Logout
          </span>
        </f7-link>
      </f7-nav-right>
    </f7-navbar>

    <span class="page-message">Please select a chat to start messaging</span>
  </f7-page>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import { isAfter } from 'date-fns';
import removeTokenFromLocalStorage from '@/js/helpers/removeTokenFromLocalStorage.js';

import UserTime from '@/components/UserTime.vue';

export default {
  name: 'Home',

  components: {
    UserTime
  },

  computed: {
    ...mapState({
      appConfig: state => state.appConfig,
      user: state => state.user.info,
      balanceLoad: state => state.user.balanceLoad,
      proofreadCount: state => state.proofread.proofreads.length,
      bookingCount: state =>
        state.user.booking.filter(lesson => isAfter(new Date(lesson.start), new Date())).length
    })
  },

  methods: {
    logOut() {
      this.setUserInfo({});
      this.authorizeUser(false);

      removeTokenFromLocalStorage();
    },

    openCalendar() {},

    ...mapMutations({
      authorizeUser: 'auth/AUTHORIZE_USER',
      setUserInfo: 'user/SET_USER_INFO'
    })
  }
};
</script>

<style lang="scss">
.page-home {
  .page-content {
    background-color: #f7f7fb;
  }

  --f7-button-padding-horizontal: 25px;
  --f7-button-box-shadow: 0 4px 8px 0 rgba(50, 172, 245, 0.3);
}

.button-with-badge {
  .margin-left-half.badge {
    margin-right: -5px;
    --f7-badge-size: 18px;
  }
}
</style>
